import React from 'react';
import IconWrapper from '../IconWrapper';
const TraingleUpIcon = (props) => (React.createElement(IconWrapper, Object.assign({}, props, { viewBox: "0 0 12 7", size: "xsmall" }),
    React.createElement("path", { d: "M0.749999 6.71252L6 0.712524L11.25 6.71252L0.749999 6.71252Z" })));
export default TraingleUpIcon;
//# sourceMappingURL=TraingleUpIcon.js.map